import styled from 'styled-components';

export const ModalButtons = styled.div`
  > button {
    margin-top 10px;
  }
`;

export const TextSubHeaderModal = styled.h2`
  font-family: 'Inter';
  font-size: 16px;
  font-weight: bold;
  width: 100%;
`;

export const ModalFooter = styled.div`
  margin-top: 64px;
`;

export const ModalBody = styled.div`
  font-size: 16px;
  line-height: 20px;
  color: #333333;
`;

export const ModalParaghaph = styled.p`
  font-size: 14px;
  color: #333333;
`;

export const TextHeaderModal = styled.h1`
  font-family: 'Inter';
  font-size: 20px;
  font-weight: bold;
  width: 100%;
`;

export const ModalHeader = styled.div`
  font-size: 20px;
  line-height: 24px;
  letter-spacing: -0.25px;
  display: flex;
  justify-content: space-between;
  button {
    cursor: pointer;
    border: 0;
    background-color: #ffffff;
  }
`;

export const PolicyPrivacy = styled.a`
  text-decoration: none;
  color: #005cde;
  font-family: 'Inter';
  font-weigth: 400;
  cursor: pointer;
`;
